import { injectChargingSessionApi } from '@delmonicos/shared-sdk/libs/emsp/src/clients/redux/back-office/charging-session.service';
import { baseApi } from '@service/base.api';

export const chargingSessionApi = injectChargingSessionApi(baseApi);

export const { useGetChargesQuery, useGetChargeQuery } = chargingSessionApi;
